import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { PERSISTED_SLICES } from '../persistence/persistence.registry';
import { TimesheetEffects } from './effects/timesheet.effects';
import { timesheetCollectionReducer } from './reducers/timesheet-collection.reducer';
import { TIMESHEET_COLLECTION_FEATURE_KEY } from './timesheet-collection.state';
import { selectTimesheets } from './selectors/timesheet.selector';

/**
 * Registers the timesheet store slice. Import once where the timesheet feature is
 * bootstrapped (apps/pace `TimesheetModule`), mirroring how `PaceForms2Module`
 * registers the `paceForms` feature.
 *
 * The slice registers its projection selector with the generic persistence layer, which
 * persists both timesheets to the concurrency store under the single default `timesheetSlice`
 * key. This replaces the former per-key writes through `StorageTimesheetService`
 * (`CURRENT_TIMESHEET` / `SUBMITTED_TIMESHEET`); the store is the source of truth and the
 * effect only mirrors it on save and reads it back to rehydrate.
 *
 * The companion-iOS-push notifications that used to fire alongside `updateStartOfWork` and
 * `submitTimesheetRequested` (via `TimesheetCompanionPushEffects`) now live in
 * `LocationTrackerCompanionPushEffects` — moved there because the push decision needs the
 * location-tracker slice's `shareLocation` setting and dedupe marker, not anything timesheet-owned.
 */
@NgModule({
    imports: [
        StoreModule.forFeature(TIMESHEET_COLLECTION_FEATURE_KEY, timesheetCollectionReducer),
        EffectsModule.forFeature([TimesheetEffects]),
    ],
    providers: [
        {
            provide: PERSISTED_SLICES,
            multi: true,
            useValue: {
                featureKey: TIMESHEET_COLLECTION_FEATURE_KEY,
                persistSelector: selectTimesheets,
            },
        },
    ],
})
export class TimesheetStoreModule {}
